/* tslint:disable */
/* eslint-disable */

/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { GeneratedApiClient, GeneratedHttpClientConstraints, RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    CheckRegistrationRequest,
    CheckRegistrationResponse,
    DeleteDriverRegistrationDocumentRequest,
    DriverRegistrationInput,
    DriverRegistrationLogResponse,
    DriverRegistrationLogResponseWithCompanyData,
    FleetUploadedDocument,
    GetDriverPortalRegistrationFormFieldsResponse,
    GetDriverRegistrationCarModelsResponse,
    GetDriverRegistrationDocumentUrlResponse,
    GetDriverRegistrationDocumentsSetResponse,
    GetDriverRegistrationFormDataResponse,
    GetDriverRegistrationMinimalFormDataResponse,
    PaymentFormResponse,
    RegisterWithMarketingRequest,
    SubmittedDriverRegistrationLogResponse,
    StandardRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.NONE;
    Sharding: ShardingStrategy.NONE;
    StandardRequest: StandardRequest;
}

export interface GetDriverRegistrationCarModelsRequest {
    hash: string;
}
export interface GetDriverRegistrationDocumentUrlRequest {
    id: number;
    hash: string;
}
export interface GetDriverRegistrationDocumentsSetRequest {
    hash: string;
    language: string;
}
export interface GetDriverRegistrationFormDataRequest {
    is_commute: 0 | 1;
}
export interface GetDriverRegistrationFormFieldsRequest {
    hash: string;
}
export interface GetDriverRegistrationLogRequest {
    hash: string;
}
export interface GetDriverRegistrationPaymentFormDataRequest {
    hash: string;
}
export interface GetSubmittedDriverRegistrationLogRequest {
    hash: string;
}
export interface UploadDriverRegistrationDocument2Multipart {
    hash: string;
    expires?: string;
    language?: string;
}
export interface V2UploadDriverRegistrationDocumentMultipart {
    hash: string;
    document_type: string;
    expires?: string;
    language?: string;
}


class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public checkRegistration = async (body: CheckRegistrationRequest, opts?: TRequestOptions): Promise<CheckRegistrationResponse>  => {
            return this.httpClient.sendRequest<CheckRegistrationResponse>({
                path: '/driverPortal/checkRegistration',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deleteDriverRegistrationDocument = async (body: DeleteDriverRegistrationDocumentRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/driverPortal/deleteDriverRegistrationDocument',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getDriverRegistrationCarModels = async (query: GetDriverRegistrationCarModelsRequest, opts?: TRequestOptions): Promise<GetDriverRegistrationCarModelsResponse>  => {
            return this.httpClient.sendRequest<GetDriverRegistrationCarModelsResponse>({
                path: '/driverPortal/getDriverRegistrationCarModels',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getDriverRegistrationDocumentUrl = async (query: GetDriverRegistrationDocumentUrlRequest, opts?: TRequestOptions): Promise<GetDriverRegistrationDocumentUrlResponse>  => {
            return this.httpClient.sendRequest<GetDriverRegistrationDocumentUrlResponse>({
                path: '/driverPortal/getDriverRegistrationDocumentUrl',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getDriverRegistrationDocumentsSet = async (query: GetDriverRegistrationDocumentsSetRequest, opts?: TRequestOptions): Promise<GetDriverRegistrationDocumentsSetResponse>  => {
            return this.httpClient.sendRequest<GetDriverRegistrationDocumentsSetResponse>({
                path: '/driverPortal/getDriverRegistrationDocumentsSet',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getDriverRegistrationFormData = async (query: GetDriverRegistrationFormDataRequest, opts?: TRequestOptions): Promise<GetDriverRegistrationFormDataResponse>  => {
            return this.httpClient.sendRequest<GetDriverRegistrationFormDataResponse>({
                path: '/driverPortal/getDriverRegistrationFormData',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getDriverRegistrationFormFields = async (query: GetDriverRegistrationFormFieldsRequest, opts?: TRequestOptions): Promise<GetDriverPortalRegistrationFormFieldsResponse>  => {
            return this.httpClient.sendRequest<GetDriverPortalRegistrationFormFieldsResponse>({
                path: '/driverPortal/getDriverRegistrationFormFields',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getDriverRegistrationLog = async (query: GetDriverRegistrationLogRequest, opts?: TRequestOptions): Promise<DriverRegistrationLogResponseWithCompanyData>  => {
            return this.httpClient.sendRequest<DriverRegistrationLogResponseWithCompanyData>({
                path: '/driverPortal/getDriverRegistrationLog',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getDriverRegistrationPaymentFormData = async (query: GetDriverRegistrationPaymentFormDataRequest, opts?: TRequestOptions): Promise<PaymentFormResponse>  => {
            return this.httpClient.sendRequest<PaymentFormResponse>({
                path: '/driverPortal/getDriverRegistrationPaymentFormData',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getSubmittedDriverRegistrationLog = async (query: GetSubmittedDriverRegistrationLogRequest, opts?: TRequestOptions): Promise<SubmittedDriverRegistrationLogResponse>  => {
            return this.httpClient.sendRequest<SubmittedDriverRegistrationLogResponse>({
                path: '/driverPortal/getSubmittedDriverRegistrationLog',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public register = async (body: RegisterWithMarketingRequest, opts?: TRequestOptions): Promise<DriverRegistrationLogResponse>  => {
            return this.httpClient.sendRequest<DriverRegistrationLogResponse>({
                path: '/driverPortal/register',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public resubmitDriverRegistrationDocuments = async (body: DriverRegistrationInput, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/driverPortal/resubmitDriverRegistrationDocuments',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public uploadDriverRegistrationDocument = async (body: UploadDriverRegistrationDocument2Multipart, opts?: TRequestOptions): Promise<FleetUploadedDocument>  => {
            return this.httpClient.sendRequest<FleetUploadedDocument>({
                path: '/driverPortal/uploadDriverRegistrationDocument',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public v2GetDriverRegistrationFormData = async (opts?: TRequestOptions): Promise<GetDriverRegistrationMinimalFormDataResponse>  => {
            return this.httpClient.sendRequest<GetDriverRegistrationMinimalFormDataResponse>({
                path: '/driverPortal/v2/getDriverRegistrationFormData',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public v2UploadDriverRegistrationDocument = async (body: V2UploadDriverRegistrationDocumentMultipart, files: Record<'file', File>, opts?: TRequestOptions): Promise<FleetUploadedDocument>  => {
            return this.httpClient.sendRequest<FleetUploadedDocument>({
                path: '/driverPortal/v2/uploadDriverRegistrationDocument',
                service_id: 'fleet-registration',
                subdomain: 'driverportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                files,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};
